import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiConfiguration } from '@klubovna/api-client';
import {
  productCategoriesControllerCreate,
  ProductCategoriesControllerCreate$Params,
  productCategoriesControllerDelete,
  productCategoriesControllerFindAll,
  ProductCategoriesControllerFindAll$Params,
  productCategoriesControllerUpdate,
  ProductCategoriesControllerUpdate$Params,
} from '@klubovna/api-client';
import { CreateProductCategoryDto, ProductCategory, UpdateProductCategoryDto } from '@klubovna/api-client';
import { PaginatedResponse, toPaginatedResponse } from '@klubovna/api-client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ProductCategoriesApiService {
  private http = inject(HttpClient);
  private apiConfig = inject(ApiConfiguration);

  findAll(params?: ProductCategoriesControllerFindAll$Params): Observable<PaginatedResponse<ProductCategory>> {
    return productCategoriesControllerFindAll(this.http, this.apiConfig.rootUrl, params)
      .pipe(map(response => toPaginatedResponse<ProductCategory>(response.body)));
  }

  create(categoryData: CreateProductCategoryDto): Observable<ProductCategory> {
    const params: ProductCategoriesControllerCreate$Params = {
      body: categoryData,
    };
    return productCategoriesControllerCreate(this.http, this.apiConfig.rootUrl, params)
      .pipe(map(response => response.body as ProductCategory));
  }

  update(id: string, categoryData: UpdateProductCategoryDto): Observable<ProductCategory> {
    const params: ProductCategoriesControllerUpdate$Params = {
      id,
      body: categoryData,
    };
    return productCategoriesControllerUpdate(this.http, this.apiConfig.rootUrl, params)
      .pipe(map(response => response.body as ProductCategory));
  }

  delete(id: string): Observable<void> {
    return productCategoriesControllerDelete(this.http, this.apiConfig.rootUrl, { id })
      .pipe(map(() => undefined));
  }
}
